const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || 'https://api.beetlestore.online').replace(/\/$/, '');
const API_KEY     = process.env.REACT_APP_BACKEND_API_KEY || '';
const HEADERS     = { 'Content-Type': 'application/json', 'X-API-Key': API_KEY };

async function apiFetch(path, opts = {}) {
  const res  = await fetch(`${BACKEND_URL}${path}`, { headers: HEADERS, ...opts });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `Error ${res.status}`);
  return data;
}

/** { reviews: [...], summary: {count, average} } — published reviews only. */
export function getProductReviews(productId) {
  return apiFetch(`/api/reviews/product/${productId}`);
}

export function hideReview(reviewId) {
  return apiFetch(`/api/reviews/${reviewId}/hide`, { method: 'POST' });
}

export function showReview(reviewId) {
  return apiFetch(`/api/reviews/${reviewId}/show`, { method: 'POST' });
}
